/* eslint-disable react/jsx-props-no-spreading */
/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import {
  Box,
  MenuItem,
  MenuItemProps as MuiSelectMenuItemProps,
  Typography,
} from '@material-ui/core';
import clsx from 'clsx';
import React from 'react';
import useStyles from './SimpleSelect.styles';

interface SelectMenuItemProps extends MuiSelectMenuItemProps {
  disabled?: boolean;
  testId: string;
  description?: React.ReactNode;
}

const SelectMenuItem = <C extends React.ElementType = 'button'>(
  props: SelectMenuItemProps &
    React.ComponentProps<C> & {
      component?: C;
    }
) => {
  const { children, disabled, className, testId, description, ...rest } = props;
  const classes = useStyles();
  return (
    <MenuItem
      data-cyid={`${testId}-select-item`}
      {...rest}
      className={clsx(className, {
        [classes.selectMenuItem]: true,
        [classes.selectMenuItemDisabled]: disabled,
      })}
    >
      <Box>
        {children}
        {description && (
          <Typography variant="body2" className={classes.description}>
            {description}
          </Typography>
        )}
      </Box>
    </MenuItem>
  );
};

export default SelectMenuItem;
